var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6323 6.35707V8.39138C10.6556 8.89854 10.7871 9.39392 11.0173 9.84152L11.8048 11.1834C11.9102 11.3645 11.9749 11.568 11.994 11.7788C12.0131 11.9897 11.9862 12.2023 11.9151 12.4007C11.844 12.599 11.7307 12.7781 11.5837 12.9244C11.4367 13.0707 11.2598 13.1803 11.0662 13.2452C8.11164 14.2588 4.92283 14.2588 1.96825 13.2452C1.76742 13.1912 1.58205 13.0876 1.42782 12.9431C1.27359 12.7987 1.15504 12.6176 1.08221 12.4154C1.00938 12.2131 0.984413 11.9956 1.00942 11.7811C1.03442 11.5667 1.10866 11.3616 1.22585 11.1834L2.01445 9.84095C2.24953 9.39506 2.38329 8.89897 2.40544 8.39081V6.35707C2.42309 5.23302 2.86423 4.16123 3.63373 3.37283C4.40323 2.58442 5.43943 2.14258 6.51888 2.14258C7.59833 2.14258 8.63453 2.58442 9.40403 3.37283C10.1735 4.16123 10.6147 5.23302 10.6323 6.35707Z",
    stroke: "#8899B4",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.68153 2.32446C7.48364 2.26373 7.28133 2.21987 7.07661 2.19331C6.50065 2.11395 5.91517 2.15859 5.35645 2.32446C5.44836 2.08137 5.6084 1.87273 5.81575 1.72569C6.02309 1.57864 6.26813 1.5 6.51899 1.5C6.76984 1.5 7.01488 1.57864 7.22223 1.72569C7.42957 1.87273 7.58962 2.08137 7.68153 2.32446Z",
    stroke: "#8899B4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.40511 13.5371C8.40366 14.0574 8.20451 14.556 7.85117 14.9239C7.49783 15.2918 7.01904 15.499 6.51942 15.5004C6.01989 15.4992 5.54109 15.2923 5.1875 14.9248C4.83431 14.5565 4.63543 14.0576 4.63428 13.5371",
    stroke: "#8899B4",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.638f51d513904202c83ea0aa5ce30526.svg";
export { ForwardRef as ReactComponent };